<app-panel
  titleKey="project.steps.rfq.invitationPreview.companyEmployee"
  tooltipKey="project.steps.rfq.invitationPreview.companyEmployee.tooltip"
>
  <p-table [value]="inputObject()" [tableStyle]="{'min-width': '50rem'}">
    <ng-template #header>
      <tr>
        <th>{{ 'common.office.location' | transloco }}</th>
        <th>{{ 'project.steps.companyInfo.categorySalaried' | transloco }}</th>
        <th>{{ 'project.steps.companyInfo.categoryIndustrial' | transloco }}</th>
        <th>{{ 'project.steps.companyInfo.categoryContingent' | transloco }}</th>
        <th>{{ 'project.steps.companyInfo.kpiHcTotal' | transloco }}</th>
        <th>{{ 'project.steps.companyInfo.kpiFteTotal' | transloco }}</th>
      </tr>
    </ng-template>

    <ng-template #body let-row>
      <tr>
        <td>{{ row.office.name }}</td>
        <td>{{ row.salariedHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ row.industrialHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ row.contingentHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ row.totalHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ row.totalFte | appNumber: '1.0-2' }}</td>
      </tr>
    </ng-template>

    <ng-template #footer>
      <tr class="font-bold">
        <td>{{ 'common.total' | transloco }}</td>
        <td>{{ summaryData().salariedHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ summaryData().industrialHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ summaryData().contingentHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ summaryData().totalHeadcount | appNumber: '1.0-0' }}</td>
        <td>{{ summaryData().totalFte | appNumber: '1.0-2' }}</td>
      </tr>
    </ng-template>
  </p-table>
</app-panel>
